<template>
  <div class="account_menu_main_w">
    <div class="head fz12 c_1A1A1A d_flex justify_content_sb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>我的账户</el-breadcrumb-item>
        <el-breadcrumb-item>账户设置</el-breadcrumb-item>
      </el-breadcrumb>

      <div class="d_flex">
        <span>当前登录账号：</span>
        <span class="c_0983CC">{{ userinfo.username }}</span>
        <span class="span_1" @click="doLogout('/')">退出</span>
      </div>
    </div>

    <ul class="ul_1">
      <li class="li_1">
        <img
          src="@/assets/images/account_11.png"
          alt=""
          class="float_l img_1"
        >
        <div class="d_flex align_item_c justify_content_sb">
          <div>
            <div class="div_1 c_121212 font_w_bold fz14">密码修改</div>
            <div class="c333 fz14">
              建议您定期更换密码，设置安全性高的密码可以使帐号更安全
            </div>
          </div>

          <router-link to="/account/modifypsw">
            <el-button
              type="primary"
              size="mini"
              class="bc_0983CC button_1"
              style="padding: 8px 33px; border-color: #0983cc"
            >修改</el-button>
          </router-link>
        </div>
      </li>

      <li class="li_1">
        <img
          src="@/assets/images/account_12.png"
          alt=""
          class="float_l img_1"
        >
        <div class="d_flex align_item_c justify_content_sb">
          <div>
            <div class="div_1 c_121212 font_w_bold fz14">号码更换</div>
            <div class="c333 fz14">
              安全手机可以用于登录帐号，重置密码或其他安全验证
            </div>
          </div>

          <router-link to="/account/replacephone">
            <el-button
              type="primary"
              size="mini"
              class="bc_0983CC button_1"
              style="padding: 8px 33px; border-color: #0983cc"
            >更换</el-button>
          </router-link>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters(['userinfo'])
  },
  methods: {
    ...mapActions({
      'doLogout': 'user/doLogout'
    })
  }
}
</script>

<style lang="scss" scoped>
.account_menu_main_w {
  width: 970px;
  height: 667px;
  box-sizing: border-box;
  border: 1px solid #dbdbdb;
  box-shadow: 0px 2px 6px 0px rgba(204, 204, 204, 0.6);

  .head {
    padding: 19px 20px;
    background: #e6e6e6;
  }

  .span_1 {
    margin: 0 0 0 8px;
    &:hover{
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .block_title_w::before {
    top: -4px;
  }
  .block_title_w {
    .l_title {
      font-size: 16px;
    }
  }
  .ul_1 {
    // margin: 6px 0 0 0;
  }
  .li_1 {
    padding: 24px 20px;
    border-bottom: 1px dashed #ccc;
  }
  .img_1 {
    margin: 0 8px 0 0;
  }
  .div_1 {
    margin: 0 0 13px 0;
  }
  .button_1{
    font-size: 14px;
    &:hover{
      background-color: rgba($color: #0983cc, $alpha: .9);
    }
  }
}
</style>
